import { Pipe, PipeTransform } from '@angular/core'
import { AddressSchema } from '@mmx/shared'
import { filter } from 'lodash'

@Pipe({
  name: 'address',
  standalone: false,
})
export class AddressPipe implements PipeTransform {
  transform(address?: AddressSchema, singleLine = false) {
    if (address) {
      return filter([
        address.address1,
        address.address2,
        address.address3,
        address.city ? address.city + ', ' + address.state : '',
        address.county ? address.county : '',
        address.country,
        address.zip,
      ]).join(singleLine ? ', ' : '<br>')
    } else {
      return ''
    }
  }
}
